import React, { Component }from "react";
import Row from "reactstrap/lib/Row";
import  { Col } from "reactstrap/lib";
import { Button } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import { groupArrayOnKey } from "../../../actions";
import { Icon } from "@material-ui/core";
import moment from "moment";


const DOC_TYPE_TEXT = {
    "PAN": "PAN Card (KYC)",
    "AADHAAR": "Aadhaar Card",
    "PAN_JOB": "PAN Card (Exclusively for Projects)",
    "AADHAAR_JOB": "Aadhaar Card (Exclusively for Projects)",
    "GST": "Business GST",
    "FIRM_PAN": "Business PAN"

}

class UserDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documents : []
        }
    }

    componentDidMount(){
        this.fetchDocuments();
    }

   
      fetchDocuments = async () => {
        store.dispatch(setLoader(true))
        try{
            let docTypes = ["PAN", "AADHAAR", "PAN_JOB", "AADHAAR_JOB", "GST", "FIRM_PAN"];
            var body = { user_id : this.props.user_id, type: docTypes }
            let documentResp = await ApiEndpoints.UserProfile.fetchDocument(body)
            let documents = documentResp.data.data;

            documents = documents.sort((a, b) => docTypes.indexOf(a.type) - docTypes.indexOf(b.type));
            this.setState({ documents })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
      } 
      
      deleteDocument = async (doc) => { 
        if(!window.confirm("Are you sure?")) return;
        store.dispatch(setLoader(true))
        try{
            var body = { user_id : this.props.user_id, user_document_id: doc.user_document_id }
            await ApiEndpoints.UserProfile.deleteDocument(body);
            await this.fetchDocuments();
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
      }

      
      downloadFileByID = async (fileId) => {
        store.dispatch(setLoader(true))
        try{
            var fileBody = {file_id : fileId}
            let urlResp = await ApiEndpoints.Files.getFileID(fileBody);
            let fileUrl = urlResp.data.data[0] ? urlResp.data.data[0].url : null;

            window.open(fileUrl, "_blank")
          
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
      }

      
    render() {
        let { documents } = this.state;
        return (
            <>
               <Row>
                    <Col xs={12}>
                        { documents.length ? <>
                            <div className="my-3">
                               {
                                documents.map(doc => {
                                    return (
                                        <div className="border shadow-sm mb-3" style={{borderRadius: 8, overflow: "hidden"}}>
                                            <Row className="py-2 border-bottom  bg-secondary text-light">
                                                <Col><span className="ml-3 font-weight-bold small">{DOC_TYPE_TEXT[doc.type] || doc.type}</span></Col>
                                                <Col xs="auto" className="text-right">
                                                    {!!doc.file_id && <Button onClick={() => this.downloadFileByID(doc.file_id)} type="button" color="link" className="mr-1 p-0 text-light" style={{ fontSize: "12px"}}>Front <Icon style={{fontSize: 12}} className="align-middle">visibility</Icon></Button>}
                                                    {!!doc.file_id2 && <Button onClick={() => this.downloadFileByID(doc.file_id2)} type="button"  color="link" className=" mr-1 p-0 text-light" style={{fontSize: "12px"}}>Back <Icon  style={{fontSize: 12}} className="align-middle">visibility</Icon></Button>}
                                                </Col>
                                            </Row>
                                            <div className="p-2 m-2" style={{position: "relative"}}>
                                                {doc.type.includes("_JOB") && <Icon onClick={() => this.deleteDocument(doc)} className="clickable p-3" style={{position: "absolute", right: 0, top: 0, fontSize: 14}}>delete</Icon>}
                                                <Row>
                                                    <Col>
                                                        <span className="d-block">Number: {(doc.number || "").slice(0, 3)}****{(doc.number || "").slice(6)}</span>
                                                    </Col>
                                                    <Col xs={"auto"}>
                                                        <span className={"font-weight-bold small "+ (doc.status ===1 ? "text-success" : doc.status === 2 ? "text-danger" : "text-secondary")}>{doc.status ===1 ? "Verified" : doc.status === 2 ? "Rejected" : ""}</span>
                                                    </Col>
                                                </Row>
                                                <Row>  
                                                    <Col>
                                                        <span className="small d-block">Created: {moment(doc.created_on).utcOffset("+05:30").format("Do MMM'YY HH:mm")}</span>
                                                        {!!doc.modified_on && doc.created_on === doc.modified_on && <span className="small d-block">Updated: {moment(doc.modified_on).utcOffset("+05:30").format("Do MMM'YY HH:mm")}</span>}
                                                    </Col>
                                                </Row>
                                                {!!doc.description && <i className="small text-danger d-block mt-1">{doc.description}</i>}
                                            </div>
                                        </div>
                                    )
                                })
                               }
                            </div>
                           
                        </>
                        : <em className="m-4 text-secondary d-block">No Aadhaar/PAN details added</em> }
                    </Col>
                </Row>
            </>
           
        );
    }
}
export default UserDocuments;
